'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phoneValidator = undefined;

var _reactIntl = require('react-intl');

var _verify = require('helpers/verify');

var messages = (0, _reactIntl.defineMessages)({
  required: {
    id: 'validators.phone.invalidNumber',
    defaultMessage: 'Please provide a valid phone number.'
  }
});

var phoneValidator = exports.phoneValidator = function phoneValidator(val, _ref) {
  var country = _ref.country;

  // Note about stripping 1 from beginning of USA/CAN numbers:
  // the NAPA does not allow for area codes starting with 1 so this is safe to do
  if ((0, _verify.isBlank)(val) || ['USA', 'CAN'].includes(country) && val.replace(/^\+?1/, '').length !== 10) {
    return messages.required;
  }
};